<div *ngIf="(showSnowAnimation$ | async) === true" class="falling-items">
  <div class="falling-items__item" *ngFor="let symbol of items">
    {{ symbol }}
  </div>
</div>
